export default "__VITE_ASSET__B3M5xdn4__"